import React from 'react'
interface Props {
  shareOption?: any
}
const ShareOption: React.FC<Props> = ({ shareOption }) => {
  return (
    <div className="flex justify-center md:flex-col pb-8 md:pr-8 pr-2 space-x-4 md:space-x-0 md:my-0 md:space-y-2">
      {shareOption?.map((sh: any) => (
        <div
          key={sh.label}
          className="flex items-center justify-center text-xs rounded-full"
        >
          <a href={sh.href} id={sh.css} target="_blank">
            {sh.src ? (
              <img src={sh.src} className="object-contain w-12 h-12" />
            ) : (
              sh.label
            )}
          </a>
        </div>
      ))}
    </div>
  )
}
export default ShareOption
